var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","stroke":"#000","viewBox":"0 0 12 7"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 1l5 5 5-5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }